import Vue from 'vue';
import App from './App.vue';
import store from './store/index';
import i18n from './i18n/index';
import buildRouter from './router';
import config from './config';
import './mixins';

Vue.config.productionTip = false;

document.addEventListener('DOMContentLoaded', () => {
  const router = buildRouter(config.baseUrl);
  new Vue({
    store,
    router,
    i18n,
    render: (h) => h(App),
  }).$mount('#search-app');

  // register global event listeners
  window.addEventListener('search:setQuery', (event) => {
    const { query, taxonPermalink } = event.detail;

    const newHTTPQuery = { ...router.currentRoute.query, page: 1 };
    newHTTPQuery.query = query;

    if (taxonPermalink === '') {
      router.push({ name: 'home', query: newHTTPQuery });
    } else {
      router
        .push({ name: `category${i18n.locale.toUpperCase()}`, params: { taxonPermalink }, query: newHTTPQuery })
        .catch(() => {});
    }
  });
});

export default { i18n };
